import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

const categoryBanners: Record<string, string> = {
  "yule-bagua": "https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20news%20collage%20style%20banner%2C%20celebrity%20gossip%20theme%2C%20warm%20dramatic%20lighting%2C%20mosaic%20of%20news%20images%2C%20editorial%20design%2C%20bold%20contrast%2C%20red%20and%20dark%20tones%2C%20modern%20media%20aesthetic&width=1200&height=600&seq=category-banner-yule&orientation=landscape",
  "mingxing-heiliao": "https://readdy.ai/api/search-image?query=A%20mysterious%20dramatic%20banner%20with%20spotlight%20on%20a%20dark%20stage%2C%20celebrity%20scandal%20theme%2C%20cinematic%20lighting%2C%20deep%20shadows%2C%20red%20velvet%20curtain%20vibe%2C%20editorial%20photography%2C%20dark%20elegant%20mood&width=1200&height=600&seq=category-banner-mingxing&orientation=landscape",
  "wanghong-fancha": "https://readdy.ai/api/search-image?query=A%20split%20personality%20concept%20banner%2C%20one%20side%20glamorous%20filtered%20selfie%20the%20other%20natural%20candid%2C%20social%20media%20influencer%20theme%2C%20vibrant%20pink%20and%20cool%20blue%20contrast%2C%20editorial%20beauty%20photography&width=1200&height=600&seq=category-banner-wanghong&orientation=landscape",
  "meiri-dasai": "https://readdy.ai/api/search-image?query=A%20dynamic%20fire%20and%20competition%20themed%20banner%2C%20versus%20concept%2C%20glowing%20neon%20lights%2C%20epic%20showdown%20atmosphere%2C%20intense%20orange%20and%20black%20colors%2C%20sports%20entertainment%20style%2C%20dramatic%20lighting&width=1200&height=600&seq=category-banner-meiri&orientation=landscape",
  "shishi-redian": "https://readdy.ai/api/search-image?query=A%20breaking%20news%20urgent%20theme%20banner%2C%20flashing%20red%20alert%20vibe%2C%20live%20newsroom%20atmosphere%2C%20multiple%20screens%20showing%20headlines%2C%20dynamic%20fast%20paced%20media%20style%2C%20bold%20red%20and%20dark%20gray%20colors&width=1200&height=600&seq=category-banner-shishi&orientation=landscape",
};

interface Props {
  categorySlug: string;
}

export default function CategoryHeader({ categorySlug }: Props) {
  const category = categories.find((c) => c.slug === categorySlug);

  if (!category) {
    return null;
  }

  const bannerUrl = categoryBanners[categorySlug] || "";

  return (
    <section className="relative w-full pt-16 md:pt-18">
      <div className="w-full px-4 md:px-10 py-8 md:py-14">
        <nav className="mb-6" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-xs">
            <li>
              <Link to="/" className="text-foreground-400 hover:text-foreground-700 whitespace-nowrap cursor-pointer transition-colors duration-200">
                首页
              </Link>
            </li>
            <li>
              <span className="text-foreground-300">/</span>
            </li>
            <li>
              <span className="text-accent-600 font-medium">{category.name}</span>
            </li>
          </ol>
        </nav>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[40%] flex flex-col justify-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-5">
              {category.name}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-7 max-w-md">
              {category.description}
            </p>
            <div className="flex gap-3 text-sm text-foreground-400">
              <span>聚合全网最新{category.name}内容</span>
              <span>·</span>
              <span>实时更新不打烊</span>
            </div>
          </div>

          <div className="lg:w-[60%]">
            <div className="rounded-2xl overflow-hidden h-48 md:h-72">
              <img
                src={bannerUrl}
                alt={category.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}